import { db, auth } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export const OFFER_INTENT_KINDS = {
  LISTING_CTA_TRADE: 'listing_cta_trade',
  LISTING_CTA_PURCHASE: 'listing_cta_purchase',
  MATCH_CTA_TRADE: 'match_cta_trade',
  /** "Hey, I'm interested" tapped on a listing (beta). */
  LISTING_INTEREST_SENT: 'listing_interest_sent',
  /** Listing owner opened an interest signal to respond to it. */
  INTEREST_OPENED: 'interest_opened',
  /** Owner passed on an interest signal. */
  INTEREST_DISMISSED: 'interest_dismissed',
  /** Owner moved from an interest signal into composing a trade offer. */
  INTEREST_TO_OFFER: 'interest_to_offer',
  /** Logged only after a trade offer document is successfully created (starts at zero vs legacy DB). */
  TRADE_OFFER_SUBMITTED: 'trade_offer_submitted',
  /** Logged only after a purchase offer document is successfully created. */
  PURCHASE_OFFER_SUBMITTED: 'purchase_offer_submitted',
};

/**
 * Funnel tracking → Firestore offerIntentEvents (admin Data tab).
 * Fire-and-forget; safe to call before navigation.
 *
 * @param {string} kind - OFFER_INTENT_KINDS value
 * @param {Record<string, unknown>} [extra] - e.g. listingId, matchId, tradeOfferId, purchaseOfferId
 */
export const recordOfferIntentEvent = async (kind, extra = {}) => {
  try {
    const user = auth.currentUser;
    if (!user) return;

    await addDoc(collection(db, 'offerIntentEvents'), {
      kind,
      userId: user.uid,
      createdAt: serverTimestamp(),
      ...extra,
    });
  } catch (err) {
    console.error('offerIntentEvents:', err);
  }
};
